/**
 * Equipment discovery reads — P-Q010, P-Q011, P-Q012, P-Q013, P-Q014.
 *
 * The types here mirror what the backend ACTUALLY serialises, not what a
 * marketplace UI would like to have. The anonymous view (L0, §11.2) is five
 * fields; there is no location, no photograph and no price on a unit, because
 * exposing a registration number or a yard address is how a competitor finds a
 * machine off-platform. Anything a screen wants beyond these fields has to come
 * from the catalogue (P-Q005/6) or from the unit's own sub-resources.
 */
import { apiGet, request } from '../client.js';
/** P-Q011. The only search there is: structured filters, no free text. */
export async function searchEquipment(body) {
    const result = await request('/v1/equipment:search', {
        method: 'POST',
        body,
    });
    return result.data;
}
/** P-Q010 — the simple published listing. No cursor; `limit` only. */
export async function listEquipment(limit = 20) {
    const result = await apiGet('/v1/equipment', {
        limit,
    });
    return result.items;
}
/** P-Q012. A unit that exists but is not published is a 404, never a 403. */
export async function fetchEquipment(id) {
    return apiGet(`/v1/equipment/${id}`);
}
/** P-Q013. `from` and `to` are mandatory — the window is the caller's choice. */
export async function fetchAvailability(id, from, to) {
    return apiGet(`/v1/equipment/${id}/availability`, { from, to });
}
export async function fetchRateCard(id) {
    return apiGet(`/v1/equipment/${id}/rate-card`);
}
//# sourceMappingURL=equipment.js.map